import { FC, memo, useMemo } from 'react'
import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import Link from 'next/link'

import { Notification } from 'types'
import { ActivitiesModuleBrand, Id } from 'components'
import { formatDateToString, formatHourToString } from 'utils/transforms/date'
import { CITIZEN_PROFILE_ROUTES } from 'CitizenProfile/constants/routes'

type Props = {
  notification: Notification
  setNotificationAsReaded: () => Promise<void>
}

const NotificationNewOriginActivity: FC<Props> = ({ notification, setNotificationAsReaded }) => {
  const pathToCitizenProfileOnOriginsActivities = useMemo(() => {
    return {
      pathname: CITIZEN_PROFILE_ROUTES.CITIZEN_PROFILE_GENERAL.ACTIVITIES.replace(
        '[citizenSlug]',
        notification.unified_person_slug as string
      ),
      query: { activitySlug: notification.origin_activity_slug as string },
    }
  }, [])

  return (
    <Link href={pathToCitizenProfileOnOriginsActivities} target="_blank">
      <Flex
        className="accessible"
        rounded="none"
        position="relative"
        align="center"
        gap={4}
        py={2}
        px={4}
        _hover={{ bg: 'lightPrimary' }}
        onClick={setNotificationAsReaded}
      >
        <ActivitiesModuleBrand />

        <Stack spacing={1}>
          <Flex align="center" gap={1}>
            <Id id={notification.origin_activity_activity_type_id} />
            <Text>Nova atividade: {notification.origin_activity_activity_type_name}</Text>
          </Flex>

          <Flex align="center" gap={1}>
            <Text variant="secondary" fontSize="xs">
              Criado em
            </Text>
            <Text variant="secondary" fontSize="xs">
              {formatDateToString(notification.origin_activity_created_at)} ás {formatHourToString(notification.origin_activity_created_at)}
            </Text>
          </Flex>
        </Stack>

        {!notification.opened_at && <Box position="absolute" top={3} right={4} bg="success" height="10px" width="10px" rounded="full" />}
      </Flex>
    </Link>
  )
}

export default memo(NotificationNewOriginActivity)
